/**
 * Light India-UPI commentary — English only, dry, not rude.
 * Shown sparingly (Home aside / share tagline). Never shame income, family, caste, or gender.
 */

/** @type {Record<string, string[]>} */
export const SNARK_BY_TAG = {
  micro: [
    'Those under-₹100 taps add up quieter than EMI reminders.',
    '₹40 here, ₹60 there — classic death by a thousand QR codes.',
    'Chai money is still money. Shocking, we know.',
    'Your wallet did not notice. Your month did.',
    'Small taps, big spreadsheet energy.',
    'The ₹99s are plotting against you in a group chat.',
    'Micro spends: individually innocent, collectively theatrical.',
    'Nobody budgets for “just one more UPI”.',
    'Those tiny taps were not rounding errors.',
    'You did not overspend once. You overspent forty times politely.',
    '₹50 feels free until you meet thirty of them.',
    'Local vendor taps: the stealth mode of spending.',
    'Under ₹100 is not “nothing”. It is many nothings.',
    'Your micro-taps have unionised.',
    'QR codes do not come with a “are you sure?” for ₹35.',
    'Parking change energy, but make it digital.',
    'The month’s plot was written in ₹20 chapters.',
    'Small QR, loud total.',
    'You collected micro-debits like stamps.',
    '₹70 does not feel like a decision. That is the trick.',
    'Vendor taps: low drama, high count.',
    'The “harmless” column in your statement asks for a moment.',
    'Many soft taps. One firm total.',
    'Under a hundred rupees: India’s favourite optical illusion.',
    'Your UPI history has a lot of supporting actors.',
  ],
  qcommerce: [
    'Blinkit at 11 PM is rarely an emergency. It is a mood.',
    'Ten-minute delivery: convenience with a surcharge personality.',
    'Zepto fees are the modern “service charge” of impatience.',
    'You ordered groceries faster than you opened the kitchen cupboard.',
    'Instamart knows your address better than some relatives.',
    'Quick commerce: when “I’ll go tomorrow” loses every debate.',
    'That delivery tip was optional. Your timing was not.',
    'You paid for speed. The milk was the side quest.',
    'BB Now is not a lifestyle. It is a recurring cameo.',
    'Your fridge is fine. Your impulse was not.',
    'Same-day grocery: the plot twist your budget did not request.',
    'You did not need it in ten minutes. You needed the dopamine.',
    'Quick commerce receipts read like a comedy of urgency.',
    '“Out of stock at home” is a bold claim at midnight.',
    'Delivery in minutes. Reflection in months.',
    'The kirana was open. Curiosity was faster.',
    'Ice cream logistics at 1 AM: impressive, expensive.',
    '“Only bread” became a four-item cart. Classic.',
    'Dark stores never sleep. Neither did your debit.',
    'Convenience fee: paying rent for impatience.',
    'You saved a trip. Spent a subplot.',
    'Ten-minute promise, thirty-day consequence.',
    'The bag arrived. The budget filed a note.',
    'Quick commerce: India inventing a new way to say “later”.',
    'Pin code loyalty is a real relationship now.',
  ],
  food: [
    'Swiggy/Zomato: your kitchen’s most consistent competitor.',
    'Delivery bags have seen more of your evenings than your stove.',
    'That “I’ll cook tomorrow” streak is still pending.',
    'Food apps: subscription to not washing vessels.',
    'Your top food app deserves a loyalty card and a warning label.',
    'Ordering out is not a personality. It is trending that way though.',
    'Packaging fees are the small print of hunger.',
    'You know the menu better than the restaurant staff.',
    '“Just this once” has a monthly recurring calendar invite.',
    'Home-cooked plans vs delivery reality: scoreboard available.',
    'Your favourite restaurant now recognises the UPI ping.',
    'Rain + hunger = algorithm victory.',
    'Zomato Gold feelings without the gold discipline.',
    'The delivery guy has become a supporting character in your week.',
    'Cooking is free. Decision fatigue is expensive.',
    'Biryani frequency is a leading indicator.',
    '“Healthy bowl” ordered after two fries weeks. Balance.',
    'Restaurant packaging saw more of your flat than guests.',
    'Coupon hunting is cardio for some people.',
    'Same restaurant, third time this fortnight. Dedication.',
    'Delivery radius knows your moods.',
    'Stove: present. Motivation: on another network.',
    '“Share platter” for one is a bold genre.',
    'Food app search history: a memoir.',
    'You did not dine out. You imported dinner.',
  ],
  late_night: [
    'Post-10 PM food orders: the plot twist nobody budgeted.',
    'Late-night taps are rarely about nutrition.',
    'Hunger after 11 has a UPI accent.',
    'Your bedtime snack has logistics now.',
    'Night orders: when willpower clocks out early.',
    'The algorithm thrives between 10 and 2.',
    'Sleep schedule vs food schedule: one of them won.',
    'Late-night UPI: the softest form of chaos.',
    'Tomorrow-you will have opinions about tonight-you.',
    'Scrolling menus at midnight is a sport with fees.',
    'Lights out. Cart open.',
    'Night hunger invents emergencies.',
    'The 11:47 PM order will be discussed at breakfast.',
    'Late deliveries: plot armour for “just once”.',
    'Moonlight and packaging fees.',
  ],
  p2p: [
    'Friends, family, and the eternal “I’ll pay you later” ledger.',
    'People taps vs shop taps — India special: both win.',
    'Splitting bills is love. Forgetting who owes whom is tradition.',
    'P2P: the unofficial mutual fund of your friend circle.',
    '“Send na” is a complete sentence in this country.',
    'Family UPI: emotionally free, financially visible.',
    'You are either collecting or sending. Rarely neither.',
    'Group trip settlements: the final boss of WhatsApp.',
    'Paying for someone else: soft power, hard debit.',
    'The “temporary loan” that became a lifestyle.',
    '“I’ll settle on Monday” — a national proverb.',
    'Splitwise energy without opening Splitwise.',
    'Cousin requests arrive faster than EMI reminders.',
    'Friendship is free. Shared Ubers are not.',
    'The group chat has a treasurer. It is you.',
  ],
  subscriptions: [
    'Subscriptions: the quiet roommates of your bank balance.',
    'Recurring charges do not need reminders. They are the reminder.',
    'That trial ended. The billing did not get the memo.',
    'OTT stacks: more profiles than episodes finished.',
    'Monthly renewals: death by calendar invite.',
    'You cancelled the intention. The charge stayed employed.',
    'Free trials are temporary. Auto-pay is forever-adjacent.',
    'Subscription count rising faster than watch time.',
    'Phantom renewals: the horror genre for wallets.',
    '“I’ll cancel after this month” — classic cliffhanger.',
    'Three OTTs, one free evening. Maths.',
    'Cloud storage you forgot you needed, billed faithfully.',
    'Auto-pay: loyalty without the loyalty.',
    'You renewed accidentally. The product did not mind.',
  ],
  salary: [
    'Salary week confidence vs month-end honesty: different genres.',
    'Day 1 energy. Day 28 maths.',
    'The month always starts with optimism and ends with Excel.',
    'First-week taps have main-character energy.',
    'Month-end you is a better auditor than salary-day you.',
    'Income landed. Ambition followed. Balance sheet negotiated.',
    'Credit of salary. Debit of vibe.',
    'Payday brunch has entered the chat.',
    'Week one: generous. Week four: forensic.',
    'The calendar turns. So does the spending tone.',
  ],
  general: [
    'UPI made spending frictionless. That was the feature and the bug.',
    'No cash does not mean no cost. Just quieter exits.',
    'Your phone is a wallet with opinions.',
    'Scan. Enter. Done. Regret optional, delayed.',
    'Offline audit: because screenshots of statements are not vibes.',
    'If it needs a QR, it will find you.',
    'Spenderly does not judge. It just has the receipts.',
    'The app stayed local. The spending did not stay subtle.',
    'Reality check: available without a bank login or a TED Talk.',
    'You tracked it. That already puts you ahead of “I’ll check later”.',
    'Money left quietly. The chart made noise.',
    'Indian spending plot: convenience first, reflection later.',
    'EMI mindset for coffee is advanced capitalism.',
    '“It was only ₹199” — famous last words of many months.',
    'Cash used to hurt. UPI whispers.',
    'Your category tags are doing more honesty than your memory.',
    'Budgeting starts when the story stops sounding cute.',
    'The leak was never dramatic. It was consistent.',
    'One statement PDF later, the mystery novel ends.',
    'You did not need another lecture. You needed a total.',
    'PhonePe/GPay history is a biography with poor narration until now.',
    'The notification was soft. The month was not.',
    'Frictionless pay, friction-full reflection.',
    'Your taps had a theme. It was “easy”.',
    'Numbers do not scold. They just arrive.',
    'Local-first tracking: drama stays on your device.',
    'The QR economy runs on optimism and PIN.',
    '“I’ll remember this spend” — unreliable narrator.',
    'A quiet debit is still a debit with good manners.',
    'Statement PDFs: the least fun bestsellers.',
    'You came for clarity. Clarity brought friends.',
    'India went cashless. Habits did not go quiet.',
    'The total is not rude. It is punctual.',
    'Every app wants a tap. Few want a summary.',
    'Your spending arc needed a season finale. Here it is.',
  ],
  share: [
    'Sharing anonymously because the numbers already said enough.',
    'Persona unlocked. Dignity optional.',
    'This card contains no bank logins and mild emotional damage.',
    'For friends who still say “UPI is free”.',
    'Proof that “I don’t spend much” needs a sequel.',
    'Export-ready honesty. Caption at your own risk.',
    'No names. Just vibes and micro-taps.',
    'Send this to the group that always says “one more order”.',
    'Anonymous flex: honesty without naming names.',
    'Share if you dare. Or just screenshot for yourself.',
    'Persona card: the softest roast you’ll consent to.',
    'No account numbers. Plenty of character development.',
  ],
  metro: [
    'Metro card top-ups: the rare UPI that feels virtuous.',
    'Commute spends: boring, necessary, still countable.',
    'Office-park lunch vs delivery: the weekday dilemma.',
    'Cab surge and food surge should not share a calendar day.',
    '“I’ll start taking the metro” — said before the auto won.',
    'Rapido vs metro: a daily referendum on patience.',
    'Office Wi-Fi strong. Lunch discipline weaker.',
    'Parking + petrol + “just coffee”: the commute trilogy.',
    'Hybrid WFH days somehow still find a delivery app.',
    'Cab receipts: when time wins and budget files a complaint.',
  ],
  festivity: [
    'Festival season: when budgets become suggestions.',
    'Gifting season has a UPI soundtrack.',
    'Sale tabs open. Willpower on leave.',
    'Diwali maths hits different when the PDF arrives.',
    'Wedding season contributions: emotionally mandatory, fiscally visible.',
    'Amazon sale energy vs bank balance energy: different time zones.',
    '“Just browsing” lasted three checkouts.',
    'Ethnic wear haul: culturally correct, fiscally loud.',
    'Gift envelopes got digital. The awkwardness stayed analog.',
    'New year resolution: fewer taps. January: loading…',
  ],
  chai: [
    'Tea stall UPI: civilisation’s softest debit.',
    'Cutting chai economics: small glass, long month.',
    'Office pantry free. Still found a paid cup somehow.',
    '₹20–₹40 taps: the background music of Indian days.',
    'Filter coffee loyalty is a personality and a line item.',
    'That “quick chai” became a weekly recurring meeting.',
    'Vada pav money is still money with a receipt trail.',
    'Street snack QR: heritage meets NPCI.',
  ],
  office: [
    'Team lunch settlements: democracy with a UPI QR.',
    '“I’ll get this one” — said the person who always gets this one.',
    'Birthday treat season hits harder than appraisal season.',
    'Printer jammed. Swiggy did not.',
    'Standup at 10. Delivery estimate at 12:40.',
    'WFH snack drawer vs office canteen: both appear in the PDF.',
    'Manager approved leave. UPI approved lunch.',
    'Expense claims wish they were this organised.',
  ],
  optimism: [
    '“From next month I’ll track properly” — classic trailer.',
    'SIP starts Monday. Delivery starts tonight.',
    'Budget spreadsheet opened. Food app opened harder.',
    'You said “enough ordering”. The app sent a coupon.',
    'Discipline is free. Convenience has a tip option.',
    'The plan was thrift. The cart was comedy.',
    'Future-you left notes. Present-you ordered dessert.',
    '“I’ll cook this week” remains an unmerged PR.',
  ],
};

/** Flat list for random/day-based picks */
export const ALL_SNARK = Object.values(SNARK_BY_TAG).flat();

function hashSeed(str) {
  let h = 2166136261;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/**
 * Pick one line. Prefer tags matching current behaviour; fall back to general.
 * Deterministic for a given seed (e.g. date + insight id) so it does not flicker.
 */
export function pickSnark(seed, tags = []) {
  const pools = [];
  for (const tag of tags) {
    if (SNARK_BY_TAG[tag]?.length) pools.push(...SNARK_BY_TAG[tag]);
  }
  if (!pools.length) pools.push(...SNARK_BY_TAG.general, ...SNARK_BY_TAG.micro);

  const idx = hashSeed(seed) % pools.length;
  return pools[idx];
}

/**
 * ~1 in 3 days show an aside; keeps it from feeling spammy.
 */
export function shouldShowSnarkToday(date = new Date()) {
  const key = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  return hashSeed(key) % 3 !== 0;
}

export function insightTagsForSnark(insightId) {
  const map = {
    chai_tap: ['micro', 'chai'],
    qcommerce: ['qcommerce', 'optimism'],
    late_night: ['late_night', 'food'],
    unnamed_vpa: ['micro', 'chai'],
    subscriptions: ['subscriptions'],
    p2p_split: ['p2p', 'office'],
    needs_tag: ['general'],
    remembered_top: ['general', 'optimism'],
  };
  return map[insightId] || ['general'];
}
